import {r as register} from '@theme/theme-sections';
import {l as load} from '@theme/theme-sections';
import {F as Flickity} from '@theme/flickity';
import {observeSectionVisibility} from '@theme/section-visibility';
import {createSectionAutoplay} from '@theme/section-autoplay';
import '@theme/flickity-fade';
import '@theme/_commonjsHelpers';

const sectionType = 'trust-icons';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};

if (!registeredSections[sectionType]) {
  register(sectionType, {
    onLoad() {
      this.sliderElement = this.container.querySelector('[data-slider]');
      if (!this.sliderElement) return;
      this.stopObservingVisibility = observeSectionVisibility(this.container, (visible) => {
        this.sectionVisible = visible;
        if (visible) this.initializeCarousel();
        this.autoplay?.setVisible(visible);
      });
    },
    initializeCarousel() {
      if (this.flickity || !this.sliderElement) return;
      this.flickity = new Flickity(this.sliderElement, {
        prevNextButtons: false,
        autoPlay: false,
        pageDots: true,
        adaptiveHeight: false,
        fade: true,
        watchCSS: true,
      });
      this.autoplay = createSectionAutoplay(this.flickity, {
        interval: this.container.dataset.autoplay === 'true' ? Number(this.container.dataset.autoplaySpeed) : false,
      });
      this.autoplay.setVisible(Boolean(this.sectionVisible));
    },
    onSelect() {
      if (!window.Shopify?.designMode) return;
      this.initializeCarousel();
      this.autoplay?.setEditorPaused(true);
    },
    onBlockSelect(event) {
      if (!window.Shopify?.designMode) return;
      const slide = event.target.closest?.('.trust-icons__slide');
      const index = Array.from(this.container.querySelectorAll('.trust-icons__slide')).indexOf(slide);
      if (index < 0) return;
      this.onSelect();
      this.flickity?.select(index);
    },
    onBlockDeselect() {
      if (window.Shopify?.designMode) this.autoplay?.setEditorPaused(false);
    },
    onDeselect() {
      if (window.Shopify?.designMode) this.autoplay?.setEditorPaused(false);
    },
    onUnload() {
      this.stopObservingVisibility?.();
      this.stopObservingVisibility = null;
      this.autoplay?.destroy();
      this.autoplay = null;
      this.flickity?.destroy();
      this.flickity = null;
      this.sliderElement = null;
      this.sectionVisible = false;
    },
  });
}
load(sectionType);
